var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 36.905,
    height: 36.905,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BUDGET"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BUDGET",
    clipPath: "url(#clip-BUDGET)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2626",
    "data-name": "Groupe 2626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2624",
    "data-name": "Groupe 2624",
    transform: "translate(4.952 4.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2623",
    "data-name": "Groupe 2623",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    d: "M14.6-1.1a15.7,15.7,0,0,1,11.1,26.808A15.7,15.7,0,1,1,3.5,3.5,15.6,15.6,0,0,1,14.6-1.1Zm0,29.2A13.5,13.5,0,0,0,24.149,5.055,13.5,13.5,0,1,0,5.055,24.149,13.413,13.413,0,0,0,14.6,28.1Z",
    transform: "translate(3.851 4.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7039",
    "data-name": "Trac\\xE9 7039",
    d: "M20.342,10.083a10.739,10.739,0,1,1-7.594,3.145A10.669,10.669,0,0,1,20.342,10.083Zm0,19.275A8.536,8.536,0,1,0,11.8,20.822,8.546,8.546,0,0,0,20.342,29.358Z",
    transform: "translate(-1.888 -1.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7040",
    "data-name": "Trac\\xE9 7040",
    d: "M24.9,22.2a3.182,3.182,0,1,1-3.183-3.18h0A3.18,3.18,0,0,1,24.9,22.2",
    transform: "translate(-3.271 -3.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7041",
    "data-name": "Trac\\xE9 7041",
    d: "M21.72,17.924h0a4.283,4.283,0,1,1-4.284,4.285A4.286,4.286,0,0,1,21.724,17.924Z",
    transform: "translate(-3.271 -3.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_110",
    "data-name": "Ligne 110",
    d: "M1.1,8.419H-1.1V0H1.1Z",
    transform: "translate(18.453 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_111",
    "data-name": "Ligne 111",
    d: "M1.1,8.419H-1.1V0H1.1Z",
    transform: "translate(18.453 28.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_112",
    "data-name": "Ligne 112",
    d: "M8.419,1.1H0V-1.1H8.419Z",
    transform: "translate(0 18.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_113",
    "data-name": "Ligne 113",
    d: "M8.419,1.1H0V-1.1H8.419Z",
    transform: "translate(28.486 18.453)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/BUDGET.4f43c453384c31a42c155aad2fae1825.svg";
export { ForwardRef as ReactComponent };